module.exports = __webpack_public_path__ + "img/5.58770cf3.png";